import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-unused-vars */

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-25 11:28:08
 * @LastEditTime: 2021-12-20 20:10:23
 * @LastEditors: wangshengqiang
 * @Description: 试算逻辑
 */
import React, { useEffect } from 'react';
import { debounce } from 'lodash';
import { getQueryParam } from '@/utils/queryString';
import { findModuleFromPage, getFetchBaseData } from '@/utils/utils';
import request from '@/utils/request';
import { dispatch, getState, setFormValue } from '@/store';
import SingleAlert from '@/components/SingleAlert/singleAlert';
import ZaToast from '@/components/ZaToast';
import { isPreviewMode, hasEmptyValue } from '@/utils/tool';

const setItemInfo = (index, key, value) => {
  setFormValue(`insured[${index}].${key}`, value);
}; // 调用试算接口，返回试算结果


export const getCalculatedPremium = async insuredIndex => {
  // 试算传入订单号, 更新订单信息
  const data = getFetchBaseData();
  const {
    orderNo,
    encryptOrderNo
  } = getQueryParam();
  data.orderNo = orderNo;
  data.encryptOrderNo = encryptOrderNo; // data.thirdChannelCode=  "QD202103257276";
  // data.extraInfo = {
  //   canalDefine: '',
  //   originAccount: '127229',
  //   originChannel: 'QD202103257276',
  //   thirdChannelCode: 'QD202103257276',
  // };

  const opts = {
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      // 当前被保人
      insuredList: [data.insuredList[insuredIndex]]
    })
  };
  console.log(`insured trail ---- ${insuredIndex}`);
  const res = (await request('/v1/insure/premiumCalculate', opts)) || {};
  const {
    code,
    message,
    result
  } = res;

  if (Number(code)) {
    const codeList = ['20000', '20019'];

    if (codeList.includes(code)) {
      const modal = SingleAlert({
        title: '温馨提示',
        content: message,
        onCancel: () => {
          modal.hide();
        }
      });
      return;
    }

    ZaToast.show(message);
    return;
  } // 把试算结果存到store中


  const {
    insuredList
  } = result || {};
  const [{
    initialPremium
  }] = insuredList || [];
  setItemInfo(insuredIndex, 'premium', initialPremium);
};

const InsuredTrail = ({
  form,
  insuredIndex
}) => {
  const handleField = ({
    name,
    isPremiumFactor
  }) => {
    if (Array.isArray(name) && name.length) {
      // 是否是当前投保人关联的因子
      const isNeedFactor = name.some(key => {
        // 被保人/受益人
        if (/^(insured|beneficiary)\[\d+\]/.test(key)) {
          const index = key.replace(/.*\[(.*)\].*/, '$1');
          return String(index) === String(insuredIndex);
        }

        return true;
      });
      return isNeedFactor && isPremiumFactor;
    }

    return isPremiumFactor;
  };

  const formValuesStr = form.getFieldsValue(undefined, handleField);

  const fetchPremium = () => {
    getCalculatedPremium(insuredIndex);
  };

  const reTrail = debounce(() => {
    const names = form.getFieldsName(handleField);

    if (!names || names.length < 1 || isPreviewMode()) {
      console.log('没有配置试算因子或者为预览环境');
      return;
    }

    form.validateFields(names, {
      noUpdate: true
    }).then((val, err) => {
      fetchPremium();
    }).catch(e => {
      console.log('error: 试算', 'error');
    });
  }, 500);
  useEffect(() => {
    if (!hasEmptyValue(formValuesStr)) {
      reTrail();
    }
  }, [JSON.stringify(formValuesStr)]);
  return /*#__PURE__*/React.createElement("div", null);
};

export default InsuredTrail;